import LessonPage from "../../../../components/LessonPage";

export default function FarsiPage() {
  const sections = [
    {
      label: "بخش 1",
      points: 120,
      items: [
        { title: "نگاره ها", icon: "📘", link: "/classroom/class1/farsi/lesson1/review1", image: "/img1.png" },
        { title: "صدای حیوانات", icon: "🧩", link: "/classroom/class1/farsi/lesson1/review2", image: "/img2.png" },
      ],
    },
    {
      label: "بخش 2 ( نشانه ها )",
      points: 90,
      items: [
        { title: "درس اوّل  ( آ - ب )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review3", image: "/img3.png" },
        { title: "درس دوم ( اَ - د )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review4", image: "/img4.png" },
        { title: "درس سوم ( م - س )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review5", image: "/img4.png" },
        { title: "درس چهارم ( او - و - ت )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review6", image: "/img4.png" },
        { title: "درس پنجم ( ر - ن )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review7", image: "/img4.png" },
        { title: "درس ششم ( ای - ی  - ز )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review8", image: "/img4.png" },
        { title: "درس هفتم ( اِ - ه - ش )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review9", image: "/img4.png" },
        { title: "درس هشتم ( ی - اُ )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review10", image: "/img4.png" },
        { title: "درس نهم ( ک - و )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review11", image: "/img4.png" },
        { title: "درس دهم ( پ - گ )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review12", image: "/img4.png" },
        { title: "درس یازدهم ( ف - خ )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review13", image: "/img4.png" },
        { title: "درس دوازدهم ( ق - ل )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review14", image: "/img4.png" },
        { title: "درس سیزدهم ( ج - استثنا )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review15", image: "/img4.png" },
        { title: "درس چهاردهم ( ه - چ )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review16", image: "/img4.png" },
        { title: "درس پانزدهم ( ژ - خوا )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review17", image: "/img4.png" },
        { title: "روان خوانی", icon: "🧩", link: "/classroom/class1/farsi/lesson1/review18", image: "/img2.png" },
      ],
    },
    {
      label: "بخش 3",
      points: 120,
      items: [
        { title: "درس شازدهم = در بازار (تشدید -ّ - تنوین )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review19", image: "/img1.png" },
        { title: "درس هفدهم = صدای موج ( ص - ذ )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review20", image: "/img3.png" },
        { title: "درس هجدهم = علی و معصومه ( ع )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review21", image: "/img3.png" },
        { title: "درس نوزدهم =  حلزون (  ث - ح )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review22", image: "/img3.png" },
        { title: "درس بیستم = رضا ( ض - ط )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review23", image: "/img3.png" },
        { title: "درس بیست و یکم = لاک پشت و مرغابی ها ( غ )", icon: "📝", link: "/classroom/class1/farsi/lesson1/review24", image: "/img3.png" },
        { title: "تمرین", icon: "🧩", link: "/classroom/class1/farsi/lesson1/review25", image: "/img2.png" },
      ],
    },
    {
      label: "بخش 4 ( روان خوانی )",
      points: 120,
      items: [
        { title: "شادیم و پاک و خندان", icon: "📝", link: "/classroom/class1/farsi/lesson1/review26", image: "/img4.png" },
        { title: "چهار فصل", icon: "📝", link: "/classroom/class1/farsi/lesson1/review27", image: "/img4.png" },
        { title: "داستان ...", icon: "📝", link: "/classroom/class1/farsi/lesson1/review28", image: "/img4.png" },
        { title: "نیایش", icon: "📝", link: "/classroom/class1/farsi/lesson1/review29", image: "/img4.png" },
        { title: "تمرین", icon: "🧩", link: "/classroom/class1/farsi/lesson1/review30", image: "/img2.png" },
      ],
    },
    {
      label: "تمرین",
      points: 120,
      items: [
        { title: "تمرین", icon: "🧩", link: "/classroom/class1/farsi/lesson1/review31", image: "/img2.png" },
      ],
    },
  ];

  return (
    <LessonPage
      title="فارسی کلاس اول"
      sections={sections}
      onClose={() => window.history.back()}
    />
  );
}